import httpService from "./http.service";

class CoordinationService {
  getCoordinationsUrl = "/coordination";
  //   getGlassesColorsUrl = "/glasses-colors/";

  coordinate = (id, model) => {
    return httpService.patch("/coordination/coordinate/" + id, model);
  };

  getUserCorrdinate = (userId) => {
    return httpService.get(`/coordination?userId=${userId}&status=accepted`)
  }
  //   editGlasses = (id, model) => {
  //     return httpService.patch("/glasses/" + id, model);
  //   };
  //   deleteGlasses = (id) => {
  //     return httpService.delete("/glasses/" + id);
  //   };

  //   createGlassesColor = (model) => {
  //     return httpService.form("/glasses-colors", model, "createGlassesColor");
  //   };
  //   editGlassesColor = (id, model) => {
  //     return httpService.form(
  //       "/glasses-colors/" + id,
  //       model,
  //       "editGlassesColor",
  //       {},
  //       "patch"
  //     );
  //   };
  //   deleteGlassesColor = (id) => {
  //     return httpService.delete("/glasses-colors/" + id);
  //   };
}

const coordinationService = new CoordinationService();
export default coordinationService;
